import { createContext } from "react"
export const AgreementContext = createContext()
